import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../environments/environment";
import { Observable } from "rxjs";
import { HttpService } from "../../shared/services/http.service";

@Injectable({
  providedIn: "root",
})
export class RegisterService {
  private HTTPheaders;
  
  constructor(private http: HttpClient, private httpService: HttpService) {
    this.HTTPheaders = {
      "Content-Type": "application/json",
    };
  }
  getEventForParticipants(
    token: string,
    tokenParticipant: string
  ): Observable<any> {
    return this.http.get<any>(
      `${env.baseUrl}events/${token}/participants/${tokenParticipant}`,
      this.httpService.getOptions(this.HTTPheaders)
    );
  }

  getEventForRegister(
    token: string,
    tokenParticipant: string
  ): Observable<any> {
    return this.http.get<any>(
      `${env.baseUrl}events/${token}/participants/${tokenParticipant}/register`,
      this.httpService.getOptions(this.HTTPheaders)
    );
  }

  getQrCode(
    token: string,
    tokenParticipant: string
  ): Observable<any> {
    return this.http.get<any>(
      `${env.baseUrl}events/${token}/participants/${tokenParticipant}/get-qr`,
      { responseType: 'arraybuffer' as 'json' }
    );
  }

  storeRegisterForEvent(token: string, tokenParticipant: string, body: any) {
    return this.http.post<any>(
      `${env.baseUrl}events/${token}/participants/${tokenParticipant}/register`,
      body,
      this.httpService.getOptions(this.HTTPheaders)
    );
  }

  getEventForRegisterGuest(
    token: string,
  ): Observable<any> {
    return this.http.get<any>(
      `${env.baseUrl}events/${token}`,
      this.httpService.getOptions(this.HTTPheaders)
    );
  }

  storeRegisterForGuest(token: string, body: any) {
    return this.http.post<any>(
      `${env.baseUrl}events/${token}/participants/register`,
      body,
      this.httpService.getOptions(this.HTTPheaders)
    );
  }
}
